module.exports = __webpack_public_path__ + "static/media/after_sales.7acca8c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/after_sales.svg
// module id = 1090
// module chunks = 36